export enum FormControlError {
  REQUIRED = 'required',
  MIN_LENGTH = 'minlength',
  MAX_LENGTH = 'maxlength',
  PATTERN = 'pattern',
  PASSWORD_MISMATCH = 'passwordMismatch',
  PASSWORD_SAME = 'passwordSame',
  INCORRECT_PASSWORD = 'incorrectPassword',
  DATE_IN_THE_PAST = 'dateInThePast',
  DATE_IN_THE_FUTURE = 'dateInTheFuture',
  INVALID_AUTOCOMPLETE_STRING = 'invalidAutocompleteString',
  INVALID_DATE_FORMAT = 'invalidDateFormat',
  INVALID_PASSWORD = 'password',
  ISSUE_DATE_TOO_LATE = 'issueDateTooLate',
}
